import { createButton } from './createButton';

interface PaginationButtonProps {
  onClick: () => void;
  disabled: boolean;
  label: string;
}

export const PaginationButton = createButton<PaginationButtonProps>({
  className:
    'cursor-pointer rounded border border-white/[0.06] bg-zinc-900 px-3 py-1 font-mono text-[11px] text-zinc-400 transition hover:bg-zinc-800 hover:text-zinc-200 disabled:cursor-not-allowed disabled:opacity-40',
  content: (props) => props.label,
});
